import React, { useState } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import "./components.css";
import CommonButton from "./CommonButton";
import { Edit } from "./svg";
import { event } from "@/lib/analytics";
import CommonInput from "./CommonInput";
import { Formik } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import isDisposableEmail from "is-disposable-email";
import { showToast } from "../../utils/libs/toast-utilis";
import { isValidPhoneNumber } from "../../utils/libs/utils";
import OtpModal from "./OtpModal";
import {
  emailOtpVerification,
  emailResendOtpVerification,
  updateCustomer,
  usersPerformance,
} from "@/services/pricing";
import GreetingModal from "./greetingModal";

const DetailsConformationModal = ({
  show,
  onHide,
  details,
  onUpdate,
  quoteId,
  selectedPackageId,
  selectedPackageName = "",
}) => {
  const { name, email, mobile } = details || {};
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showGreetingModal, setShowGreetingModal] = useState(false);

  const [editMode, setEditMode] = useState({
    name: false,
    email: false,
    mobile: false,
  });
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: name,
    email: email,
    mobile: mobile,
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const toggleEdit = (field) => {
    setEditMode((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const initialValues = {
    name: name,
    email: email,
    mobile: mobile,
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    mobile: Yup.string()
      .required("Mobile number is required")
      .test("is-valid", "Enter a valid phone number", (value) => {
        const digitsOnly = value?.replace(/\D/g, "");
        return digitsOnly && digitsOnly.length >= 10 && digitsOnly.length <= 15;
      }),
  });
  const sendOTP = async (userDetails) => {
    event({
      action: "confirm customer details",
      params: {
        ...userDetails,
        page: "project_price_page",
        _id: details?._id,
      },
    });
    // with out change any field
    if (
      JSON.stringify({ name, email, mobile }) === JSON.stringify(userDetails)
    ) {
      onHide();
      setShowGreetingModal(true);
      usersPerformance({
        payload: {
          customStatus: "Opted",
          packageId: [selectedPackageId],
        },
        leadId: quoteId,
      });
      return;
    }
    const formattedPhone = userDetails?.mobile.startsWith("+")
      ? userDetails?.mobile
      : `+${userDetails?.mobile.replace(/\D/g, "")}`;
    if (isDisposableEmail(userDetails?.email)) {
      showToast.error("Please use a valid personal or business email address.");
      return;
    }
    if (!isValidPhoneNumber(formattedPhone)) {
      showToast.error("Please enter a valid phone number.");
      return;
    }
    setLoading(true);
    try {
      if (userDetails?.email === details?.email) {
        const res = await updateCustomer(
          {
            name: userDetails?.name,
            email: userDetails?.email,
            mobile_number: formattedPhone,
          },
          details?._id
        );
        setShowGreetingModal(true);
        usersPerformance({
          payload: {
            customStatus: "Opted",
            packageId: [selectedPackageId],
          },
          leadId: quoteId,
        });
        localStorage.setItem("authDetails", JSON.stringify(res));
        onHide();
      } else {
        const query = { _id: details?._id, email: userDetails?.email };
        await emailResendOtpVerification(query);
        setShowOtpModal(true);
        showToast.success(
          "Verification code has been sent to your email address!!"
        );
        onHide();
      }
    } catch (err) {
      if (err.message) {
        showToast.error(err.message);
      }
    }
    setLoading(false);
  };

  const verifyOTP = async (otp) => {
    if (!otp || otp.length !== 6) {
      showToast.error("Please enter a valid 6-digit OTP.");
      return;
    }

    setLoading(true);
    try {
      const formattedPhone = formData?.mobile.startsWith("+")
        ? formData?.mobile
        : `+${formData?.mobile.replace(/\D/g, "")}`;
      const res = await emailOtpVerification({
        otp: otp,
        name: formData?.name,
        email: formData?.email,
        mobile_number: formattedPhone,
        _id: details?._id,
      });
      localStorage.setItem("authDetails", JSON.stringify(res));
      setShowGreetingModal(true);
      usersPerformance({
        payload: {
          customStatus: "Opted",
          packageId: [selectedPackageId],
        },
        leadId: quoteId,
      });
      setShowOtpModal(false);
      showToast.success("User Update verified successfully!");
    } catch (error) {
      if (error.message) {
        showToast.error(error.message);
      }
      setLoading(false);
    }
  };
  const handleSubmit = (values) => {
    setFormData(values);
    sendOTP(values);
  };
  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        backdrop="static"
        keyboard={false}
        centered
        className="confirmation-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3 className="com-title" style={{ fontSize: "20px" }}>
              🎉 Thank You for Choosing the <span>{selectedPackageName}</span>{" "}
              for Your Product Development!
            </h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="edit-modal-main">
          <p className="mb-3">
            👉 To move things forward, we just need a few quick details — and
            help you <span className="bold">schedule a call</span> to kick off
            your journey with us. Let’s build something great together.🚀
          </p>
          <Formik
            initialValues={formData || initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <div>
                  <Row className="gy-3">
                    <Col md={12} sm={12}>
                      <div className="des-text">
                        <CommonInput
                          name="name"
                          value={values.name}
                          className="mb-0 des-text-common-input"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={!editMode.name}
                          error={touched.name && errors.name}
                        />
                        {!editMode.name && (
                          <Edit
                            style={{
                              fill: "#000",
                              width: "15px",
                              height: "15px",
                            }}
                            onClick={() => toggleEdit("name")}
                          />
                        )}
                      </div>
                    </Col>
                    <Col md={6} sm={12}>
                      <div className="des-text">
                        <CommonInput
                          name="email"
                          className="mb-0 des-text-common-input"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={!editMode.email}
                          error={touched.email && errors.email}
                        />
                        {/* {email || "N/A"}{" "} */}
                        {!editMode.email && (
                          <Edit
                            style={{
                              fill: "#000",
                              width: "15px",
                              height: "15px",
                            }}
                            onClick={() => toggleEdit("email")}
                          />
                        )}
                      </div>
                    </Col>
                    <Col md={6} sm={12}>
                      <div className="des-text">
                        {/* {mobile || "N/A"} */}
                        <PhoneInput
                          country={"in"}
                          value={values.mobile}
                          onChange={(value) => setFieldValue("mobile", value)}
                          inputClass="w-100 price-input"
                          inputStyle={{ width: "100%" }}
                          containerStyle={{ width: "100%" }}
                          countryCodeEditable={true}
                          placeholder="Enter mobile number"
                          disabled={!editMode.mobile}
                          inputProps={{
                            onBlur: handleBlur,
                            name: "mobile",
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleSubmit();
                            }
                          }}
                        />
                        {touched.mobile && errors.mobile && (
                          <div className="invalid-feedback d-block">
                            {errors.mobile}
                          </div>
                        )}
                        {/* <CommonInput
                        label="Mobile"
                        name="mobile"
                        value={formData?.mobile || ""}
                        onChange={handleInputChange}
                        disabled={!editMode.mobile}
                      /> */}
                        {!editMode.mobile && (
                          <Edit
                            style={{
                              fill: "#000",
                              width: "15px",
                              height: "15px",
                            }}
                            onClick={() => toggleEdit("mobile")}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="my-3" style={{ opacity: 0.7 }}>
                  <li>
                    {/* <p> */}
                    You’ve just taken a major step toward building something
                    extraordinary.
                    {/* </p> */}
                  </li>
                  <li>
                    Our team is excited to turn your vision into a high-impact,
                    scalable product.
                  </li>
                </div>
                <div className="d-flex justify-content-end gap-2 mt-3">
                  {/* <CommonButton
                    label="Edit"
                    className="black-border"
                    variant="outline"
                    type="submit"
                    icon={
                      <Edit
                        style={{ fill: "#000", width: "15px", height: "15px" }}
                      />
                    }
                  /> */}
                  {/* <Link
                    href={"https://calendly.com/greet_at_neoverce/30min"}
                    role="button"
                    target="_blank"
                  > */}
                  <CommonButton
                    label="Confirm"
                    type="submit"
                    // onClick={() => {
                    // event({
                    //   action: "book call",
                    //   params: {
                    //     page: "project_price_page",
                    //   },
                    // });
                    // onHide();
                    // }}
                  />
                  {/* </Link> */}
                </div>
              </form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      <OtpModal
        show={showOtpModal}
        onHide={() => {
          setShowOtpModal(false);
          setFormData(null);
        }}
        verifyOTP={verifyOTP}
        loading={loading}
        userDetails={{ ...formData, _id: details?._id }}
        isEdit={true}
      />
      <GreetingModal
        show={showGreetingModal}
        onUpdate={onUpdate}
        selectedPackageId={selectedPackageId}
        quoteId={quoteId}
        onHide={() => {
          setShowGreetingModal(false);
        }}
      />
    </>
  );
};

export default DetailsConformationModal;
